import React, { useState, Fragment, useEffect } from 'react';
import './style.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';
import { handleValidateObj } from 'constants/objValues/objvalues';
import SearchLocation from 'components/sales/searchLocation/searchLocation';

const Location = ({
  isSupply = false,
  isb2b = false,
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  handleValue,
  locationState,
  locationPinCode,
  pincodeData,
  getCurrentLocation = null,
  latlng,
  toastMsg,
  prefilledData = null,
  isDefalut,
  lat=null,
  lng=null,
  currentLocation=null,
  gstPinCode= null
}) => {
  const locationInput = {
    city: { id: null, value: '' },
    zone: { id: null, value: '' },
    area: { id: null, value: '' },
    address1: '',
    islocationType: { id: null, value: '' },
    pinCode: '',
    isLat: '',
    isLong: '',
    geoCity: '',
    geoState: '',
    geoCityId: '',
    geoStateId: '',
    pinId: '',
  };

  const [locationData, setlocationData] = useState(locationInput);
  const [optOption, setOptOption] = useState({
    address2: '',
    currentLocation: '',
  });
  const [isInputError, setIsInputError] = useState({
    latError: false,
    longError: false,
    pinError: false,
    crl: false,
    isPinNotFound: false,
  });
  const [isZone, setIsZone] = useState(true);
  const [isArea, setIsArea] = useState(true);
  const [isEnable, setIsEnable] = useState(true);
  const [isPincodeAvail, setIsPincodeAvail] = useState(false);
  const [isLatWrong, setIsLatWrong] = useState(false);
  const [isLongWrong, setIslongWrong] = useState(false);
  const [disableElement, setDisableElement] = useState(false);
  const coordsType = { lat: 'LAT', long: 'LONG' };

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setlocationData(locationInput);
      setOptOption({
        address2: '',
        currentLocation: '',
      });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        city,
        city_id,
        geo_pincode,
        zone,
        zone_id,
        area,
        area_id,
        geo_state,
        geo_state_id,
        geo_city,
        geo_city_id,
        location_type,
        geo_pincode_id,
        location_type_id,
        address_line_one,
        address_line_two,
        current_location,
        latitude,
        longitude,
      } = prefilledData?.lead_data;
      setlocationData({
        ...locationData,
        isLat: latitude,
        isLong: longitude,
        pinCode: `${geo_pincode}`,
        city: { id: city_id, value: city },
        zone: { id: zone_id, value: zone },
        area: { id: area_id, value: area },
        geoState: geo_state,
        geoStateId: geo_state_id,
        geoCity: geo_city,
        geoCityId: geo_city_id,
        islocationType: { id: location_type_id, value: location_type },
        pinId: geo_pincode_id,
        address1: address_line_one,
      });
      setTimeout(() => {
        setOptOption({
          ...optOption,
          currentLocation: current_location,
          address2: address_line_two,
        });
      }, 2000);
    }
  }, [prefilledData]);

  useEffect(() => {
    setlocationData({
      ...locationData,
      isLat: lat,
      isLong: lng,
    });
  },[lat,lng]);

  useEffect(() => {
    (async () => {
      await locationCity();
      await locationType();
      await locationState();
    })();
  }, []);

  const handleLocData = () => {
    if (isb2b === false) {
      const isEmpty = handleValidateObj(locationData);
      if (
        isEmpty !== false &&
        !isNaN(locationData.isLat) &&
        isFinite(locationData.isLat) &&
        Math.abs(locationData.isLat) <= 90 &&
        !isNaN(locationData.isLong) &&
        isFinite(locationData.isLong) &&
        Math.abs(locationData.isLong) <= 180
      ) {
        handleValue({
          ...locationData,
          islocationType: locationData.islocationType.id,
          city: locationData.city.id,
          zone: locationData.zone.id,
          area: locationData.area.id,
          ...optOption,
          address2: optOption.address2,
        });
      } else {
        handleValue(null);
      }
    }
    if (isb2b === true) {
      const b2bObj = { ...locationData };
      b2bObj.city = locationData.city.id;
      b2bObj.zone = locationData.zone.id;
      b2bObj.area = locationData.area.id;
      b2bObj.islocationType = locationData.islocationType.id;
      b2bObj.currentLocation = optOption.currentLocation;
      const isNotEmpty = handleValidateObj(b2bObj);
      if (isNotEmpty !== false)
        handleValue({
          ...b2bObj,
          address2: optOption.address2,
        });
    }
  };

  const handleGstLocData = () => {
      if (
        !isNaN(locationData.isLat) &&
        isFinite(locationData.isLat) &&
        Math.abs(locationData.isLat) <= 90 &&
        !isNaN(locationData.isLong) &&
        isFinite(locationData.isLong) &&
        Math.abs(locationData.isLong) <= 180
      ) {
        handleValue({
          ...locationData,
          islocationType: locationData.islocationType.id,
          city: locationData.city.id,
          zone: locationData.zone.id,
          area: locationData.area.id,
          ...optOption,
        });
      } else {
        handleValue(null);
      }
  };

  useEffect(() => {
    if(gstPinCode){
      handleGstLocData();
    }
    else{
      handleLocData();
    }
  }, [locationData, optOption]);

  const handleGpsLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        (e) => {
          let latitude = e.coords.latitude;
          let longitude = e.coords.longitude;
          getCurrentLocation(`${latitude},${longitude}`);
        },
        function (error) {
          if (error.code == error.PERMISSION_DENIED)
            setlocationData({
              ...locationData,
              isLat: '',
              isLong: '',
            });
        }
      );
    } else {
      let errorMsg = localization.geolocationNotSupport;
      setlocationData({ ...locationData, isLat: errorMsg, isLong: errorMsg });
    }
  };

  const handleLatChange = (val, type) => {
    if (type === coordsType.lat) {
      if (Number(val) === Number(locationData?.isLong)) {
        setIslongWrong(false);
        setIsLatWrong(true);
        setIsInputError({ ...isInputError, latError: true, longError: false });
        setTimeout(() => {
          setlocationData({ ...locationData, isLat: '' });
        }, 1000);
        return false;
      } else {
        setIsLatWrong(false);
        setIsInputError({ ...isInputError, latError: false });
        setlocationData({ ...locationData, isLat: val });
      }
    } else {
      if (Number(val) === Number(locationData?.isLat)) {
        setIslongWrong(true);
        setIsLatWrong(false);
        setIsInputError({ ...isInputError, latError: false, longError: true });
        setTimeout(() => {
          setlocationData({ ...locationData, isLong: '' });
        }, 1000);
        return false;
      } else {
        setIslongWrong(false);
        setIsInputError({ ...isInputError, longError: false });
        setlocationData({ ...locationData, isLong: val });
      }
    }
  };

  const handleLatLongBlur = (type) => {
    if (type !== null) {
      let lat = Number(locationData.isLat);
      let lng = Number(locationData.isLong);
      if (type === coordsType.lat) {
        if (
          !isNaN(locationData.isLat) &&
          isFinite(lat) &&
          Math.abs(lat) <= 90 &&
          isLatWrong === false
        ) {
          setIsInputError({ ...isInputError, latError: false });
          return false;
        } else {
          setIsInputError({ ...isInputError, latError: true });
        }
      } else {
        if (
          !isNaN(locationData.isLong) &&
          isFinite(lng) &&
          Math.abs(lng) <= 180 &&
          isLongWrong === false
        ) {
          setIsInputError({ ...isInputError, longError: false });
          return false;
        } else {
          setIsInputError({ ...isInputError, longError: true });
        }
      }
    }
  };

  useEffect(() => {
    handleGpsLocation();
  }, []);

  const handleCityChange = async ({ id, value }) => {
    setlocationData({
      ...locationData,
      city: { id: id, value: value },
      zone: { id: null, value: '' },
      area: { id: null, value: '' },
    });
    if (id) {
      const res = await locationZone(id);
      if (res) setIsZone(false);
    } else {
      setIsZone(true);
      setIsArea(true);
    }
  };
  const handleZoneChange = async ({ id, value }) => {
    setlocationData({
      ...locationData,
      area: { id: null, value: '' },
      zone: { id: id, value: value },
    });
    if (id) {
      const res = await locationArea(id);
      if (res) setIsArea(false);
    } else {
      setIsArea(true);
    }
  };

  const handleCurrentLocationBlur = (latlng = null) => {
    if (latlng !== null && latlng !== undefined) {
      const { lat, lng } = latlng;
      setlocationData({ ...locationData, isLat: lat, isLong: lng });
      setIsEnable(true);
    }
    if (latlng === null) {
      setIsEnable(false);
      // setlocationData({ ...locationData, isLat: "", isLong: "" });
    }
  };

  const handleCurrentLocationChange = (value) => {
    setOptOption({ ...optOption, currentLocation: value });
    localStorage.setItem('currentLocation', value);
  };

  // useEffect(() => {
  //   if (latlng !== null) {
  //     const { lat, lng, address } = latlng;
  //     if (lat !== null && lng !== null) {
  //       setlocationData({ ...locationData, isLat: lat, isLong: lng });
  //       const loc = localStorage.getItem('currentLocation');
  //       setTimeout(() => {
  //         if (loc) {
  //           if (address === loc) {
  //             setOptOption({ ...optOption, currentLocation: address });
  //           } else {
  //             setOptOption({ ...optOption, currentLocation: loc });
  //           }
  //         } else {
  //           setOptOption({ ...optOption, currentLocation: address });
  //         }
  //       }, 1000);
  //       setIsEnable(true);
  //     }
  //   }
  //   if (
  //     latlng?.lat === null ||
  //     latlng?.lng === null ||
  //     latlng?.address === null
  //   ) {
  //     setlocationData({ ...locationData, isLat: '', isLong: '' });
  //     setIsEnable(false);
  //   }
  // }, [latlng]);


  const handlePinBlur = () => {

    if (gstPinCode) {
      return;
    }
    if (
      Regex.pinCode.test(locationData.pinCode) &&
      !isNaN(locationData.pinCode)
    ) {
      locationPinCode(locationData.pinCode);
      setIsInputError({ ...isInputError, pinError: '' });
      return false;
    } else {
      setIsInputError({ ...isInputError, pinError: true });
      setlocationData({ ...locationData, geoCity: '', geoState: '' });
    }
  };

  useEffect(() => {
    if(gstPinCode){
      if (pincodeData.length) {
        let {
          city_name,
          state_name,
          geo_city_id,
          geo_state_id,
          pincode_id,
          pincode,
          address1,
          address2,
          isLat,
          isLong
        } = pincodeData[0];
        setlocationData({
          ...locationData,
          geoStateId: geo_state_id,
          geoCityId: geo_city_id,
          geoCity: city_name,
          geoState: state_name,
          pinId: pincode_id,
          pinCode: pincode,
          address1: address1,
          isLat,
          isLong
        });
        setOptOption({
          ...optOption,
          address2: address2,
        });
        setIsInputError({
          ...isInputError,
          isPinNotFound: false,
          pinError: false,
        });
        if(pincode != ''){
          setDisableElement(true)
        }
        setIsPincodeAvail(false);
      } else {
        setlocationData({ ...locationData, geoState: '', geoCity: '' });
        setIsInputError({
          ...isInputError,
          isPinNotFound: true,
          pinError: true,
        });
        setIsPincodeAvail(true);
      }

    }
    else{
    setDisableElement(false);
    if (locationData.pinCode.length) {
      if (pincodeData.length) {
        let {
          city_name,
          state_name,
          geo_city_id,
          geo_state_id,
          pincode_id,
        } = pincodeData[0];
        setlocationData({
          ...locationData,
          geoStateId: geo_state_id,
          geoCityId: geo_city_id,
          geoCity: city_name,
          geoState: state_name,
          pinId: pincode_id,
        });
        setIsInputError({
          ...isInputError,
          isPinNotFound: false,
          pinError: false,
        });
        setIsPincodeAvail(false);
      } else {
        setlocationData({ ...locationData, geoState: '', geoCity: '' });
        setIsInputError({
          ...isInputError,
          isPinNotFound: true,
          pinError: true,
        });
        setIsPincodeAvail(true);
      }
    }
  }
  }, [pincodeData]);

  return (
    <FormSection title="Location">
      <div className="form-colo">
      <DropDownInput
        label={localization.city}
        data={cities}
        getIdValue={(val) => handleCityChange(val)}
        errorMsg={localization.requiredCity}
        required
        isStarRequired={true}
        value={locationData.city.value}
      />
      <DropDownInput
        label={localization.zone}
        disabled={isZone}
        data={zones}
        value={locationData.zone.value}
        getIdValue={(val) => handleZoneChange(val)}
        errorMsg={localization.requiredZone}
        required
        isStarRequired={true}
      />
      <DropDownInput
        label={localization.area}
        disabled={isArea}
        data={areas}
        value={locationData.area.value}
        getIdValue={(val) =>
          setlocationData({
            ...locationData,
            area: { id: val.id, value: val.value },
          })
        }
        errorMsg={localization.requiredArea}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.address1}
        errorMsg={localization.isRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) =>
          setlocationData({ ...locationData, address1: val })
        }
        value={locationData.address1}
        maxLength={100}
        disabled={disableElement == true}
      />
      <ConstantInput
        label={localization.address2}
        errorMsg={localization.requiredAddress}
        type="text"
        handleChange={(val) => setOptOption({ ...optOption, address2: val })}
        value={optOption.address2}
        maxLength={50}
        disabled={disableElement == true}
      />
      <ConstantInput
        label={localization.lat}
        isStarRequired={true}
        type="text"
        value={locationData.isLat}
        handleChange={(val) => setlocationData({ ...locationData, isLat: val })}
        // disabled={isEnable}
      />
      <ConstantInput
        label={localization.lng}
        isStarRequired={true}
        type="text"
        value={locationData.isLong}
        handleChange={(val) => setlocationData({ ...locationData, isLong: val })}
        // disabled={isEnable}
      />
      <Fragment>
        {/* <SearchLocation
          handleCurrentLocationBlur={handleCurrentLocationBlur}
          isError={isInputError.crl}
          value={optOption.currentLocation}
          handleCurrentLocationChange={handleCurrentLocationChange}
        /> */}
        {/* <LabelInput
          label={localization.lat}
          errorMsg={
            isLatWrong ? localization.latValue : localization.requiredLatitude
          }
          isError={isInputError.latError}
          inputValue={locationData.isLat}
          className={`${locationData.isLat !== '' ? '' : 'empty'}`}
          type="text"
          onBlur={() => handleLatLongBlur(coordsType.lat)}
          handleChange={(e) => handleLatChange(e.target.value, coordsType.lat)}
          required
          isStarRequired={true}
          disabled={isEnable}
          maxLength={6}
          minLength={6}
        />
        <LabelInput
          label={localization.lng}
          errorMsg={
            isLongWrong ? localization.logValue : localization.requiredLongitude
          }
          isError={isInputError.longError}
          inputValue={locationData.isLong}
          type="text"
          onBlur={() => handleLatLongBlur(coordsType.long)}
          handleChange={(e) => handleLatChange(e.target.value, coordsType.long)}
          className={`${locationData.isLong !== '' ? '' : 'empty'}`}
          required
          isStarRequired={true}
          disabled={isEnable}
          maxLength={6}
          minLength={6}
        /> */}
        <DropDownInput
          label={localization.locationType}
          data={locTypesData}
          errorMsg={localization.requiredLocation}
          getIdValue={(val) =>
            setlocationData({
              ...locationData,
              islocationType: { id: val.id, value: val.value },
            })
          }
          required
          isStarRequired={true}
          value={locationData.islocationType.value}
        />
      </Fragment>
      <LabelInput
        label={localization.pinCode}
        errorMsg={
          isPincodeAvail
            ? localization.pinCodeIsNotAvailable
            : locationData.pinCode === ''
            ? localization.picodeRequired
            : localization.pinError
        }
        isError={isPincodeAvail ? isPincodeAvail : isInputError.pinError}
        inputValue={locationData.pinCode}
        type="text"
        maxLength={6}
        minLength={4}
        onBlur={handlePinBlur}
        handleChange={(e) =>
          setlocationData({ ...locationData, pinCode: e.target.value })
        }
        className={locationData.pinCode.length ? '' : 'empty'}
        required
        isStarRequired={true}
        disabled={disableElement == true}
      />
      <ConstantInput
        label={localization.geoState}
        value={locationData.geoState}
        disabled
        required
        isStarRequired={true}
        errorMsg={localization.requiredGeoState}
      />
      <ConstantInput
        label={localization.geoCity}
        value={locationData.geoCity}
        disabled
        required
        isStarRequired={true}
        errorMsg={localization.requiredGeoCity}
      />
      </div>
    </FormSection>
  );
};

export default Location;
